import React, { memo } from 'react';
import clsx from 'clsx';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1rem',
    height: '1rem',
  },
  down: {
    transform: 'rotate(180deg)',
  },
});

const ChevronIcon = ({ down }) => {
  const classes = useStyles();

  return (
    <SvgIcon
      viewBox="0 0 16 16"
      className={clsx(classes.icon, down && classes.down)}
    >
      <mask>
        <path d="M0 0H16V16H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <path d="M1.88 13L8 6.81916L14.12 13L16 11.0972L8 3L0 11.0972L1.88 13Z" />
      </g>
    </SvgIcon>
  );
};

export default memo(ChevronIcon);
